import { render } from "./ItemStockDetails.vue?vue&type=template&id=555cbdec&scoped=true"
import script from "./ItemStockDetails.vue?vue&type=script&lang=js"
export * from "./ItemStockDetails.vue?vue&type=script&lang=js"

import "./ItemStockDetails.vue?vue&type=style&index=0&id=555cbdec&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555cbdec"]])

export default __exports__